import { IKonfigurationStPos } from "../../Models/IKonfigurationStPos";

export const getUebersetzungsverhaeltnis = (
  positionen: IKonfigurationStPos[]
) => {
  if (positionen != undefined && positionen?.length > 0) {
    let uebersetzung = 1;

    for (let i = 0; i < positionen.length; i++) {
      let ratio = positionen[i]?.artikel?.sachwerte?.filter(
        (x: any) => x.nameEN == "Gear transmission ratio"
      )[0];
      const wert = ratio && ratio.wert ? Number(ratio.wert) : 0;
      uebersetzung *= wert > 0 ? wert : 1;
    }

    return uebersetzung;
  } else {
    return 0;
  }
};
